
import { ArrowRight, Clock, TrendingDown, BarChart3, Target, Zap, TrendingUp } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { problemSolutionData } from "../data/landingPageData";

export const ProblemSolutionSection = () => {
  return (
    <section className="py-16 md:py-24 px-4 bg-gradient-to-br from-slate-50 to-white">
      <div className="container mx-auto max-w-7xl">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 text-slate-900 leading-tight">
            {problemSolutionData.title}
          </h2>
          <p className="text-xl md:text-2xl text-slate-600 max-w-4xl mx-auto leading-relaxed">
            {problemSolutionData.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Problems */}
          <div className="space-y-8">
            <h3 className="text-2xl font-bold text-red-600 mb-8 flex items-center gap-3">
              <TrendingDown className="h-6 w-6" />
              Current Challenges
            </h3>
            {problemSolutionData.problems.map((problem, index) => (
              <Card key={index} className="border-red-200 bg-red-50/70 hover:bg-red-50 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 group">
                <CardHeader className="pb-4">
                  <CardTitle className="text-xl flex items-center gap-4 text-slate-900 group-hover:text-red-700 transition-colors">
                    <div className="w-12 h-12 rounded-xl bg-red-100 flex items-center justify-center group-hover:bg-red-200 transition-colors">
                      {index === 0 && <Clock className="h-6 w-6 text-red-600" />}
                      {index === 1 && <TrendingDown className="h-6 w-6 text-red-600" />}
                      {index === 2 && <BarChart3 className="h-6 w-6 text-red-600" />}
                    </div>
                    <span className="flex-1">{problem.title}</span>
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <p className="text-slate-700 text-lg leading-relaxed ml-16">{problem.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>

          {/* Solutions */}
          <div className="space-y-8">
            <h3 className="text-2xl font-bold text-emerald-600 mb-8 flex items-center gap-3">
              <TrendingUp className="h-6 w-6" />
              BrigAI Solutions
            </h3>
            {problemSolutionData.solutions.map((solution, index) => (
              <Card key={index} className="border-emerald-200 bg-emerald-50/70 hover:bg-emerald-50 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 group">
                <CardHeader className="pb-4">
                  <CardTitle className="text-xl flex items-center gap-4 text-slate-900 group-hover:text-emerald-700 transition-colors">
                    <div className="w-12 h-12 rounded-xl bg-emerald-100 flex items-center justify-center group-hover:bg-emerald-200 transition-colors">
                      {index === 0 && <Target className="h-6 w-6 text-emerald-600" />}
                      {index === 1 && <Zap className="h-6 w-6 text-emerald-600" />}
                      {index === 2 && <TrendingUp className="h-6 w-6 text-emerald-600" />}
                    </div>
                    <span className="flex-1">{solution.title}</span>
                  </CardTitle>
                </CardHeader>
                <CardContent className="pt-0">
                  <p className="text-slate-700 text-lg leading-relaxed ml-16">{solution.description}</p>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-16">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-red-50 to-emerald-50 text-slate-700 border border-slate-200 px-6 py-3 rounded-full text-sm font-medium">
            <Target className="h-4 w-4 text-red-600" />
            Transform your recruitment process with AI-native solutions
            <Zap className="h-4 w-4 text-emerald-600" />
          </div>
        </div>
      </div>
    </section>
  );
};
